import React, { Component } from "react";
import styled from "styled-components";
import ContentEditable from "react-contenteditable";
import { marked } from "marked";

const Container = styled.div`
    font-size: 14px;
    width: 100%;
    height: 100%;
    
    ul {
        margin: 10px 0px 10px 0px;
    }
    
    h1, h2, h3 {
        margin: 0;
        font-size: 16px;
    }
    
    .editable {
        outline: none;
    }
    
    p {
        margin-bottom: 10px;
        line-height: 1.4;
    }
    
    
`;

export class AiSlideContentEditor extends Component {
    render() {
        let { text, onChange } = this.props;

        let html = marked.parse(text ?? "");
        // replace \n with <br> in html
        // html = html.replace(/\n/g, "<br>");
        // strip trailing <br>
        html = html.replace(/<br>$/g, "");

        return (
            <Container>
                {/*<textarea value={slideContent} onChange={event => onChange(event.target.value)} style={{ width: "100%", marginBottom: "10px" }} placeholder="Enter slide content..." />*/}
                <ContentEditable className="editable" html={html} onChange={event => onChange(event.target.value)} placeholder="Enter a description of the slide..." />
            </Container>
        );
    }
}

